
import { Field, Form } from 'vee-validate'
import { computed, defineComponent, ref, watch } from 'vue'

import FormLabel from '@/components/forms/FormLabel.vue'
import InputError from '@/components/forms/InputError.vue'
import SegmentedRadio from '@/components/forms/SegmentedRadio.vue'
import TheModal from '@/components/TheModal.vue'
import api from '@/store/api'

const CREDIT_ACTIONS = [
  { label: '+ Add credit', value: 'add' },
  { label: '− Remove credit', value: 'remove' }
]

export default defineComponent({
  name: 'ManageAccountCreditModal',
  components: { TheModal, Form, Field, FormLabel, InputError, SegmentedRadio },
  props: {
    isOpen: { type: Boolean, default: false },
    conversationUserPairId: { type: String, required: true }
  },
  emits: ['close', 'success'],
  setup(props, { emit }) {
    const creditAction = ref('add')
    const accountCreditAmount = ref('')
    const onSubmitMessage = ref('')
    const onSubmitLog = ref('')

    watch(
      () => props.isOpen,
      open => {
        if (open) {
          creditAction.value = 'add'
          accountCreditAmount.value = ''
          onSubmitMessage.value = ''
          onSubmitLog.value = ''
        }
      }
    )

    const creditPreviewText = computed(() => {
      const amount = parseFloat(accountCreditAmount.value)
      if (!amount || isNaN(amount) || amount <= 0) return ''
      const formattedAmount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(amount)
      if (creditAction.value === 'add') {
        return `Account credit will increase by ${formattedAmount}`
      } else {
        return `Account credit will decrease by ${formattedAmount}`
      }
    })

    const fieldIsRequired = val => {
      return val ? true : 'This field is required'
    }

    function onClose() {
      emit('close')
    }

    function saveCreditModal() {
      const amount = parseFloat(accountCreditAmount.value)
      if (!amount || isNaN(amount) || amount <= 0) {
        onSubmitMessage.value = 'Please enter a valid amount'
        return
      }
      const isRemove = creditAction.value === 'remove'
      const accountCreditAmountCents = Math.round(amount * 100) * (isRemove ? -1 : 1)
      api
        .call(
          'POST',
          `conversation_user_pairs/${props.conversationUserPairId}/account_credits`,
          {
            account_credit: {
              value: accountCreditAmountCents
            }
          },
          false
        )
        .then(response => {
          const attrs = response.data.data.attributes
          emit('success', attrs?.account_credit?.format ?? null)
          emit('close')
        })
        .catch(error => {
          onSubmitMessage.value = 'Something went wrong!'
          onSubmitLog.value = error
        })
    }

    return {
      CREDIT_ACTIONS,
      creditAction,
      accountCreditAmount,
      onSubmitMessage,
      onSubmitLog,
      creditPreviewText,
      fieldIsRequired,
      onClose,
      saveCreditModal
    }
  }
})
